import { apiClient } from "./apiClient";
import { PRICE_BREAKUP_URL } from "./endpoints";
import getRetailTokenClient from "@utils/getRetailToken.client";

export const fetchPriceBreakup = async (
  slug: string,
  cityId: number
): Promise<any> => {
  const retailToken = await getRetailTokenClient();
  const customHeaders: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (retailToken) {
    customHeaders["RetailToken"] = retailToken;
  }

  return apiClient.get(
    `${PRICE_BREAKUP_URL}`,
    {
      slug,
      city_id: cityId.toString(),
    },
    {
      headers: customHeaders,
    }
  );
};
